import { getContent } from './getContent';
import { list } from './list';
import { preview } from './preview';

export const pages = {
  list,
  preview,
  getContent,
};
